import * as React from "react";
import PopoverTemplate from "@nkr/components/popover-template";
import { Glyphicon, OverlayTrigger } from "react-bootstrap";

export const renderArteriesInfoIcon = () => {
    const overlay = (
        <PopoverTemplate width='350px'>The laterality of the kidney available (L/R) and the final post-procurement anatomy of the donor kidney as it will be received and implanted by the recipient center.</PopoverTemplate>
    );

    return (
        <div style={{ marginLeft: 3 }}>
            <OverlayTrigger rootClose placement='bottom' trigger='click' overlay={overlay}>
                <Glyphicon glyph='info-sign' />
            </OverlayTrigger>
        </div>
    );
};

export const renderLkpdiInfoIcon = () => {
    const overlay = (
        <PopoverTemplate width='350px'>
            <p className='text-center'>
                <b>Donor-Recipient matches with a lower LKDPI are associated with a lower risk of graft loss</b>
            </p>
            <p className='text-center'>Research can be found at:</p>
            <p className='text-center'><a href='https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6114098/' target='_blank'>A Risk Index for Living Donor Kidney Transplantation</a></p>
        </PopoverTemplate>
    );

    return (
        <div style={{ marginLeft: 3 }}>
            <OverlayTrigger rootClose placement='bottom' trigger='click' overlay={overlay}>
                <Glyphicon glyph='info-sign' />
            </OverlayTrigger>
        </div>
    );
};

export const renderBmtMmInfoIcon = () => {
    const overlay = (
        <PopoverTemplate width='350px'>
            The "Allele Match" looks at the bidirectional match between the donor and recipient to see if there are any mismatches. In a traditional kidney
            transplant, we would look at this differently by comparing the donor alleles to the recipient. A higher number is indicative of more matches. This number being
            higher is important if the patient is ever interested in receiving a stem cell transplant to eliminate the need for immunosuppression.
        </PopoverTemplate>
    );

    return (
        <div style={{ marginLeft: 3 }}>
            <OverlayTrigger rootClose placement='bottom' trigger='click' overlay={overlay}>
                <Glyphicon glyph='info-sign' />
            </OverlayTrigger>
        </div>
    );
}


export const renderStatusInfoIcon = () => {
    const overlay = (
        <PopoverTemplate width='350px'>
            For donors listed under the Avoid Conflict tab, updates to their Medical Details will not trigger a Preselect Re-evaluation.
        </PopoverTemplate>
    );

    return (
        <div style={{ marginLeft: 3 }}>
            <OverlayTrigger rootClose placement='bottom' trigger='click' overlay={overlay}>
                <Glyphicon glyph='info-sign' />
            </OverlayTrigger>
        </div>
    );
}